export default __webpack_public_path__ + "static/media/1.31ed938d.jpeg";